import { render, staticRenderFns } from "./filter-pills.vue?vue&type=template&id=5b1c6286"
import script from "./filter-pills.vue?vue&type=script&lang=js"
export * from "./filter-pills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports